import { useEffect, useRef, useState } from "react";
import ModifyCheckTime from "../common/ModifyCheckTime/ModifyCheckTime";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import useConfiguration from "../../hooks/useConfiguration";
import { getBreakTypeList, getViewJobDetails, updateBreakInfo } from "./action";
import { viewJobSelector } from "./selector";
import * as Toasts from "../common/Toastify";
import { shiftTypeObj } from "../../helpers/data";
import { loadDailyEncounterInfo, loadShiftAwaitingCorrection } from "../ShiftsCoverage/action";
import useSessionStorage from "../../hooks/useSessionStorage";


const WorkBreakInfo = (props) => {
  const { jobId, shiftDate, claimId, masterData } = props?.data?.requestData;
  const [pickerEmptyStatus,setPickerEmptyStatus] = useState({
    checkInTime:false,
    checkoutTime:false
  })
  // Use Dispatch
  const dispatch = useDispatch();

  // Use Config
  const config = useConfiguration();

  // Use Storage Custom hook
  const storage = useSessionStorage();

  // Login credentials
  const login = storage.getItem("login");

  // Work Break Dropdown List
  const { workBreakList } = useSelector(viewJobSelector);

  // is diabled for condtion
  const isDisabled = !props?.data?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId);

  // Work Break API data initialize
  const [workBreakListData, setWorkBreakListData] = useState(
    props?.data?.jobBreakDetailsList?.map((item) => ({
      ...item,
      isActive: true,
    }))
    // tempData
  );

  // Shift Start Time , Shift End Time , Checkin Time, Checkout Time Initilize
  const [shiftTimesChanges, setShiftTimesChanges] = useState({
    shiftStartTime: props?.data?.claimedCandidateInfo?.jobDate,
    shiftEndTime: props?.data?.claimedCandidateInfo?.jobEndDate,
    checkInTime: props?.data?.claimedCandidateInfo?.checkedInDate,
    checkoutTime: props?.data?.claimedCandidateInfo?.checkedOutDate,
  });
  // Shift Timings Error message
  const [shiftTimesChangesError, setShiftTimesChangesError] = useState({});

  // Get a dropdown Work Break List
  useEffect(() => {
    if (config.baseUrl) {
        dispatch(getBreakTypeList(config.baseUrl, props?.data?.requestData?.claimId));
    }
  }, [config]);

  // Update StartDate, EndDate and break duration handle
  const updateStartEndDateValue = (e, jobBreakId, breakDate) => {
    if (e.nativeEvent.type === 'wheel') {
      return
     }
    const { name, value } = e.target;
    if (name === "breakEndDate") {
      // value = breakEndDate
      // breakDate = breakStartDate
      if (breakDate) {
        // Check check out time incase comes to null take shift end time
        const shiftCloseTime = shiftTimesChanges?.checkoutTime
          ? shiftTimesChanges?.checkoutTime
          : shiftTimesChanges?.shiftEndTime;
        // Assign a variable
        const checkOutTime = shiftCloseTime
          ? new Date(shiftCloseTime) > new Date(value)
          : true;
        if (
          new Date(breakDate) < new Date(value) &&
          new Date(breakDate) !== new Date(value) &&
          checkOutTime
        ) {
          // Update a latest value
          setWorkBreakListData((prevData) =>
            prevData.map((item) => {
              if (item.jobBreakId === jobBreakId) {
                const updatedItem = {
                  ...item,
                  [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"),
                };

                // Assuming the new key you want to update is called 'anotherKey'
                updatedItem.jobBreakTypeDuration = calculateDurationInHours(
                  name === "breakStartDate"
                    ? moment(value).format("YYYY-MM-DDTHH:mm:ss")
                    : item.breakStartDate,
                  name === "breakEndDate"
                    ? moment(value).format("YYYY-MM-DDTHH:mm:ss")
                    : item.breakEndDate
                );

                return updatedItem;
              }
              return item;
            })
          );
        } else {
          // Update old value
          setWorkBreakListData((prevData) =>
            prevData.map((item) => {
              if (item.jobBreakId === jobBreakId) {
                const updatedItem = {
                  ...item,
                  [name]: item?.breakEndDate
                    ? moment(item?.breakEndDate).format("YYYY-MM-DDTHH:mm:ss")
                    : "",
                };

                // Assuming the new key you want to update is called 'anotherKey'
                updatedItem.jobBreakTypeDuration = calculateDurationInHours(
                  name === "breakStartDate"
                    ? item?.breakEndDate
                      ? moment(item?.breakEndDate).format("YYYY-MM-DDTHH:mm:ss")
                      : ""
                    : item.breakStartDate,
                  name === "breakEndDate"
                    ? item?.breakEndDate
                      ? moment(item?.breakEndDate).format("YYYY-MM-DDTHH:mm:ss")
                      : ""
                    : item.breakEndDate
                );

                return updatedItem;
              }
              return item;
            })
          );

          if (new Date (value) <= new Date(breakDate) && new Date (value) > new Date(shiftTimesChanges?.checkInTime)) {
            Toasts.error(
                  "Please ensure that you enter the break start and end date/time details properly."
                );
          } else {
            Toasts.error(
              "Break End Date/Time should be in between the Checkin and Checkout time"
            );
          }
        }
      } 
      else {
        // Update a old value
        setWorkBreakListData((prevData) =>
          prevData.map((item) => {
            if (item.jobBreakId === jobBreakId) {
              const updatedItem = {
                ...item,
                [name]: item?.breakEndDate
                  ? moment(item?.breakEndDate).format("YYYY-MM-DDTHH:mm:ss")
                  : "",
              };

              // Assuming the new key you want to update is called 'anotherKey'
              updatedItem.jobBreakTypeDuration = calculateDurationInHours(
                name === "breakStartDate"
                  ? item?.breakEndDate
                    ? moment(item?.breakEndDate).format("YYYY-MM-DDTHH:mm:ss")
                    : ""
                  : item.breakStartDate,
                name === "breakEndDate"
                  ? item?.breakEndDate
                    ? moment(item?.breakEndDate).format("YYYY-MM-DDTHH:mm:ss")
                    : ""
                  : item.breakEndDate
              );

              return updatedItem;
            }
            return item;
          })
        );
        Toasts.error("Please add the break start date/time.");
      }
    } else if (name === "breakStartDate") {
      // value = breakStartDate
      // breakDate = breakEndDate

      if (shiftTimesChanges?.checkInTime) {
        const checkinTime = shiftTimesChanges?.checkInTime ? shiftTimesChanges?.checkInTime : shiftTimesChanges?.shiftStartTime;        
        const timeEmptyCheck = moment(breakDate).format('YYYY-MM-DDTHH:mm:ss') === '0001-01-01T00:00:00' ? null : breakDate
        const checkoutTime = timeEmptyCheck ? timeEmptyCheck : shiftTimesChanges?.checkoutTime ? shiftTimesChanges?.checkoutTime : shiftTimesChanges?.shiftEndTime;
        if (
          new Date(checkoutTime) > new Date(value) &&
          new Date(checkoutTime) !== new Date(value) &&
          new Date(checkinTime) < new Date(value) &&
          new Date(checkinTime) !== new Date(value)
        ) {
          // Updated a latest value
          setWorkBreakListData((prevData) =>
            prevData.map((item) => {
              if (item.jobBreakId === jobBreakId) {
                const updatedItem = {
                  ...item,
                  [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"),
                };

                // Assuming the new key you want to update is called 'anotherKey'
                updatedItem.jobBreakTypeDuration = calculateDurationInHours(
                  name === "breakStartDate"
                    ? moment(value).format("YYYY-MM-DDTHH:mm:ss")
                    : item.breakStartDate,
                  name === "breakEndDate"
                    ? moment(value).format("YYYY-MM-DDTHH:mm:ss")
                    : item.breakEndDate
                );

                return updatedItem;
              }
              return item;
            })
          );
        } else {
          // Updated a old value
          setWorkBreakListData((prevData) =>
            prevData.map((item) => {
              if (item.jobBreakId === jobBreakId) {
                const updatedItem = {
                  ...item,
                  [name]: item?.breakStartDate
                    ? moment(item?.breakStartDate).format("YYYY-MM-DDTHH:mm:ss")
                    : "",
                };

                // Assuming the new key you want to update is called 'anotherKey'
                updatedItem.jobBreakTypeDuration = calculateDurationInHours(
                  name === "breakStartDate"
                    ? item?.breakStartDate
                      ? moment(item?.breakStartDate).format(
                          "YYYY-MM-DDTHH:mm:ss"
                        )
                      : ""
                    : item.breakStartDate,
                  name === "breakEndDate"
                    ? item?.breakStartDate
                      ? moment(item?.breakStartDate).format(
                          "YYYY-MM-DDTHH:mm:ss"
                        )
                      : ""
                    : item.breakEndDate
                );

                return updatedItem;
              }
              return item;
            })
          );
          if (timeEmptyCheck) {
          if (new Date (value) >= new Date(breakDate) && new Date (value) < new Date(shiftTimesChanges?.checkoutTime) ) {
            Toasts.error(
                  "Please ensure that you enter the break start and end date/time details properly."
                );
          } else {
            Toasts.error(
              "Break Start Date/Time should be in between the Checkin and Checkout time"
            );
          }
        } else {
          Toasts.error(
            "Break Start Date/Time should be in between the Checkin and Checkout time"
          );
        }
        }
      } else {
        Toasts.error("Must be added a check in time");
        setWorkBreakListData((prevData) =>
          prevData.map((item) => {
            if (item.jobBreakId === jobBreakId) {
              const updatedItem = {
                ...item,
                [name]: item?.breakStartDate
                  ? moment(item?.breakStartDate).format("YYYY-MM-DDTHH:mm:ss")
                  : "",
              };

              // Assuming the new key you want to update is called 'anotherKey'
              updatedItem.jobBreakTypeDuration = calculateDurationInHours(
                name === "breakStartDate"
                  ? item?.breakStartDate
                    ? moment(item?.breakStartDate).format("YYYY-MM-DDTHH:mm:ss")
                    : ""
                  : item.breakStartDate,
                name === "breakEndDate"
                  ? item?.breakStartDate
                    ? moment(item?.breakStartDate).format("YYYY-MM-DDTHH:mm:ss")
                    : ""
                  : item.breakEndDate
              );

              return updatedItem;
            }
            return item;
          })
        );
      }
    }
  };

  // Calculate duration in hours
  const calculateDurationInHours = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);
    const durationInMilliseconds = end.diff(start);
    const durationInHours = durationInMilliseconds / (1000 * 60 * 60);

    return durationInHours.toFixed(4);
  };

  // Handle Break Type Change
  const handleBreakTypeChange = (e, jobBreakId) => {
    const { value } = e.target;
    setWorkBreakListData((prevData) =>
      prevData.map((item) => {
        if (item.jobBreakId === jobBreakId) {
          const selectedBreakType = workBreakList?.find(
            (breakItem) => breakItem.breakTypeId === parseInt(value)
          );
          return {
            ...item,
            breakTypeId: parseInt(value) ? parseInt(value) : "",
            isPaidBreak: selectedBreakType?.isPaidBreak,
            jobBreakType: selectedBreakType?.breakTypes
              ? selectedBreakType?.breakTypes
              : "",
          };
        }
        return item;
      })
    );
  };

  // Add a New Work Break
  const addWorkBreak = () => {
    const newWorkBreak = {
      breakEndDate: null,
      // shiftTimesChanges?.checkInTime
      //   ? shiftTimesChanges?.checkInTime
      //   : shiftTimesChanges?.shiftStartTime,
      breakEndDateTime: "",
      breakStartDate: null,
      // shiftTimesChanges?.checkInTime
      //   ? shiftTimesChanges?.checkInTime
      //   : shiftTimesChanges?.shiftStartTime,
      breakStartDateTime: "",
      breakTypeId: "",
      isPaidBreak: null,
      jobBreakId: Math.random(),
      jobBreakType: "",
      isActive: true,
      jobBreakTypeDuration: calculateDurationInHours(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        moment().format("YYYY-MM-DDTHH:mm:ss")
      ),
      jobBreakTypeTaken: null,
    };
    setWorkBreakListData([...workBreakListData, newWorkBreak]);
  };

  // Delete a Work Break Row
  const deleteWorkBreakRow = (index, jobBreakId) => {
    if (jobBreakId < 1) {
      // Delete the UI Temperary
      setWorkBreakListData((prevData) =>
        prevData.filter((_, i) => i !== index)
      );
    } else {
      // Is Active false for API data
      setWorkBreakListData((prevData) =>
        prevData.map((item) => {
          if (item.jobBreakId === jobBreakId) {
            const updatedItem = {
              ...item,
              ["isActive"]: false,
            };
            return updatedItem;
          }
          return item;
        })
      );
    }
  };

  const maxShiftLengthObj = masterData?.shiftPreferedLength?.at(-1);
  const maxShiftLengthHours =
    +props?.data?.jobSummeryJobsShifts?.shiftType === shiftTypeObj.multiShift ||
    +props?.data?.jobSummeryJobsShifts?.shiftType === shiftTypeObj.repost
      ? 24
      : maxShiftLengthObj?.id
      ? Math.floor(parseInt(maxShiftLengthObj?.id) / 60)
      : 26;
  const maxShiftLengthMinutes =
    +props?.data?.jobSummeryJobsShifts?.shiftType === shiftTypeObj.multiShift ||
    +props?.data?.jobSummeryJobsShifts?.shiftType === shiftTypeObj.repost
      ? 0
      : maxShiftLengthObj?.id
      ? maxShiftLengthObj?.id % 60
      : 45;

  // Shift Time handler
  const updateShiftTimeChanges = (e) => {
    if (e.nativeEvent.type === 'wheel') {
      return
     }
    const { name, value } = e.target;

    // setShiftTimesChanges({
    //   ...shiftTimesChanges,
    //   [name]: moment(
    //     value // reset key name
    //   ).format("YYYY-MM-DDTHH:mm:ss"),
    // });

    if (name === "checkoutTime") {
      if (shiftTimesChanges?.checkInTime &&  new Date() > new Date(value)) {
        
        // Step 1: Filter only active rows and convert "0001-01-01T00:00:00" to null
        const singleConvertList = workBreakListData
        .filter(row => row.isActive)  // Only active rows
        .flatMap(row => [
            row.breakStartDate,
            row.breakEndDate === "0001-01-01T00:00:00" ? null : row.breakEndDate
        ]);

      // Step 2: Find the highest value in the list, ignoring nulls
      const maxDate = singleConvertList
      .filter(date => date !== null)
      .reduce((max, current) => (new Date(current) > new Date(max) ? current : max), singleConvertList[0]);

      // Step 3: Check if the given value is greater than the highest date
      const isValueGreater = new Date(value) > new Date(maxDate);

       const isActiveCheckingArray = workBreakListData?.filter((item) => item?.isActive)?.length > 0

      const isValue = isActiveCheckingArray ? isValueGreater : true
        
        if (
          new Date(shiftTimesChanges?.checkInTime) < new Date(value) &&
          new Date(shiftTimesChanges?.checkInTime) !== new Date(value) && isValue
        ) {
          // 24 Hours Format checkout time
          const maxHoursInMins =
            maxShiftLengthHours * 60 + maxShiftLengthMinutes;
          if (value && shiftTimesChanges?.checkInTime) {
            const diffTime =
              new Date(value)?.getTime() -
              new Date(shiftTimesChanges?.checkInTime)?.getTime();
            const shiftHours = diffTime / (1000 * 60);
            if (shiftHours > maxHoursInMins) {
              // Toasts.error(
              //   `Maximum allowed shift length is ${maxShiftLengthHours} hours ${
              //     maxShiftLengthMinutes
              //       ? `and ${maxShiftLengthMinutes} mins`
              //       : ""
              //   }. Please select the shift date/time accordingly`
              // );
              // setShiftTimesChanges({
              //   ...shiftTimesChanges,
              //   [name]: shiftTimesChanges?.checkoutTime
              //     ? moment(
              //         shiftTimesChanges?.checkoutTime 
              //       ).format("YYYY-MM-DDTHH:mm:ss")
              //     : "",
              // });
              // return;
              setShiftTimesChanges({
                ...shiftTimesChanges,
                [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"),
              });
            } else {
              setShiftTimesChanges({
                ...shiftTimesChanges,
                [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"),
              });
            }
          }
        } else {
          setShiftTimesChanges({
            ...shiftTimesChanges,
            [name]: shiftTimesChanges?.checkoutTime
              ? moment(shiftTimesChanges?.checkoutTime).format(
                  "YYYY-MM-DDTHH:mm:ss"
                )
              : "",
          });
          if (!isActiveCheckingArray) {
          Toasts.error("Checkout time should be greater than check in time.");
          } else {
            Toasts.error('Checkout time should be greater than break start and end date/time.')
          }
        }
      } else {
          if (shiftTimesChanges?.checkInTime) {
            Toasts.error('Checked out time should not be greater than current time.')
          } else {
            Toasts.error('Please select the checkin time.');
          }
        setShiftTimesChanges({
          ...shiftTimesChanges,
          [name]: shiftTimesChanges?.checkoutTime
            ? moment(shiftTimesChanges?.checkoutTime).format(
                "YYYY-MM-DDTHH:mm:ss"
              )
            : "",
        });
      }
    } else if (name === "checkInTime") {
      if (shiftTimesChanges?.checkoutTime) {

      // Step 1: Filter only active rows and convert "0001-01-01T00:00:00" to null
        const singleConvertList = workBreakListData
        .filter(row => row.isActive)  // Only active rows
        .flatMap(row => [
            row.breakStartDate,
            row.breakEndDate === "0001-01-01T00:00:00" ? null : row.breakEndDate
        ]);

        const hasValidDates = singleConvertList.some(date => date !== null);

        // Only proceed with finding the minimum date and comparison if there are valid dates
        let isValueLess = false;
        if (hasValidDates) {
            // Find the lowest value in the list, ignoring nulls
            const minDate = singleConvertList
                .filter(date => date !== null)
                .reduce((min, current) => (new Date(current) < new Date(min) ? current : min), singleConvertList[0]);
        
            // Check if the given value is less than the lowest date
            isValueLess = new Date(value) < new Date(minDate);
        }

      const isValue = hasValidDates ? isValueLess : true


        // checkout time true based
        if (
          new Date(value) < new Date(shiftTimesChanges?.checkoutTime) &&
          new Date(value) !== new Date(shiftTimesChanges?.checkoutTime) && isValue
        ) {
          // 24 Hours Format checkout time
          const maxHoursInMins =
            maxShiftLengthHours * 60 + maxShiftLengthMinutes;
          if (shiftTimesChanges?.checkoutTime && value) {
            const diffTime =
              new Date(shiftTimesChanges?.checkoutTime)?.getTime() -
              new Date(value)?.getTime();
            const shiftHours = diffTime / (1000 * 60);
            if (shiftHours > maxHoursInMins) {
              // Toasts.error(
              //   `Maximum allowed shift length is ${maxShiftLengthHours} hours ${
              //     maxShiftLengthMinutes
              //       ? `and ${maxShiftLengthMinutes} mins`
              //       : ""
              //   }. Please select the shift date/time accordingly.`
              // );
              // setShiftTimesChanges({
              //   ...shiftTimesChanges,
              //   [name]: shiftTimesChanges?.checkInTime
              //     ? moment(
              //         shiftTimesChanges?.checkInTime // reset key name
              //       ).format("YYYY-MM-DDTHH:mm:ss")
              //     : "",
              // });
              // return;
              setShiftTimesChanges({
                ...shiftTimesChanges,
                [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"), // updated Value
              });
            } else {
              setShiftTimesChanges({
                ...shiftTimesChanges,
                [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"), // updated Value
              });
            }
          }
        } else {
          setShiftTimesChanges({
            ...shiftTimesChanges,
            [name]: shiftTimesChanges?.checkInTime
              ? moment(shiftTimesChanges?.checkInTime).format(
                  "YYYY-MM-DDTHH:mm:ss"
                )
              : "",
          });

          if (!hasValidDates) {
          Toasts.error("Check in time should be less than check out time.");
          } else {
            Toasts.error('Checkin time should be less than break start and end date/time.')
          }
        }
      } else {
        // shift end time based
        if (
          new Date(value) < new Date(shiftTimesChanges?.shiftEndTime) &&
          new Date(value) !== new Date(shiftTimesChanges?.shiftEndTime)
        ) {
          // 24 Hours Format checkout time
          const maxHoursInMins =
            maxShiftLengthHours * 60 + maxShiftLengthMinutes;
          if (shiftTimesChanges?.shiftEndTime && value) {
            const diffTime =
              new Date(shiftTimesChanges?.shiftEndTime)?.getTime() -
              new Date(value)?.getTime();
            const shiftHours = diffTime / (1000 * 60);
            if (shiftHours > maxHoursInMins) {
              // Toasts.error(
              //   `Maximum allowed shift length is ${maxShiftLengthHours} hours ${
              //     maxShiftLengthMinutes
              //       ? `and ${maxShiftLengthMinutes} mins`
              //       : ""
              //   }. Please select the shift date/time accordingly.`
              // );
              // setShiftTimesChanges({
              //   ...shiftTimesChanges,
              //   [name]: shiftTimesChanges?.checkInTime
              //     ? moment(
              //         shiftTimesChanges?.checkInTime // reset key name
              //       ).format("YYYY-MM-DDTHH:mm:ss")
              //     : "",
              // });
              // return;
              setShiftTimesChanges({
                ...shiftTimesChanges,
                [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"), // updated Value
              });
            } else {
              setShiftTimesChanges({
                ...shiftTimesChanges,
                [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"), // updated Value
              });
            }
          }
        } else {
          setShiftTimesChanges({
            ...shiftTimesChanges,
            [name]: shiftTimesChanges?.checkInTime
              ? moment(shiftTimesChanges?.checkInTime).format(
                  "YYYY-MM-DDTHH:mm:ss"
                )
              : "",
          });
          Toasts.error("Shift start time should be less than shift end time.");
        }
      }
    } else if (name === "shiftEndTime") {
      if (
        new Date(shiftTimesChanges?.shiftStartTime) < new Date(value) &&
        new Date(shiftTimesChanges?.shiftStartTime) !== new Date(value)
      ) {
        let shiftHours = "";
        if (value && shiftTimesChanges?.shiftStartTime) {
          const diffTime =
            new Date(value)?.getTime() -
            new Date(shiftTimesChanges?.shiftStartTime)?.getTime();
          shiftHours = diffTime / (1000 * 60);
        } else {
          shiftHours = props?.shiftHours;
        }
        const maxHoursInMins = maxShiftLengthHours * 60 + maxShiftLengthMinutes;
        if (shiftHours > maxHoursInMins) {
          // Toasts.error(
          //   `Maximum allowed shift length is ${maxShiftLengthHours} hours ${
          //     maxShiftLengthMinutes ? `and ${maxShiftLengthMinutes} mins` : ""
          //   }. Please select the shift date/time accordingly`
          // );
          // setShiftTimesChanges({
          //   ...shiftTimesChanges,
          //   [name]: moment(shiftTimesChanges?.shiftEndTime).format(
          //     "YYYY-MM-DDTHH:mm:ss"
          //   ),
          // });
          // return;
          setShiftTimesChanges({
            ...shiftTimesChanges,
            [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"),
          });
        } else {
          setShiftTimesChanges({
            ...shiftTimesChanges,
            [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"),
          });
        }
      } else {
        setShiftTimesChanges({
          ...shiftTimesChanges,
          [name]: shiftTimesChanges?.shiftEndTime
            ? moment(shiftTimesChanges?.shiftEndTime).format(
                "YYYY-MM-DDTHH:mm:ss"
              )
            : "",
        });
        Toasts.error("Shift end time should be less than shift start time.");
      }
    } else if (name === "shiftStartTime") {
      if (
        new Date(value) < new Date(shiftTimesChanges?.shiftEndTime) &&
        new Date(value) !== new Date(shiftTimesChanges?.shiftEndTime)
      ) {
        let shiftHours = "";
        if (shiftTimesChanges?.shiftEndTime && value) {
          const diffTime =
            new Date(shiftTimesChanges?.shiftEndTime)?.getTime() -
            new Date(value)?.getTime();
          shiftHours = diffTime / (1000 * 60);
        } else {
          shiftHours = props?.shiftHours;
        }
        const maxHoursInMins = maxShiftLengthHours * 60 + maxShiftLengthMinutes;
        if (shiftHours > maxHoursInMins) {
          // Toasts.error(
          //   `Maximum allowed shift length is ${maxShiftLengthHours} hours ${
          //     maxShiftLengthMinutes ? `and ${maxShiftLengthMinutes} mins` : ""
          //   }. Please select the shift date/time accordingly.`
          // );
          // setShiftTimesChanges({
          //   ...shiftTimesChanges,
          //   [name]: moment(shiftTimesChanges?.shiftStartTime).format(
          //     "YYYY-MM-DDTHH:mm:ss"
          //   ),
          // });
          // return;
          setShiftTimesChanges({
            ...shiftTimesChanges,
            [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"),
          });
        } else {
          setShiftTimesChanges({
            ...shiftTimesChanges,
            [name]: moment(value).format("YYYY-MM-DDTHH:mm:ss"),
          });
        }
      } else {
        setShiftTimesChanges({
          ...shiftTimesChanges,
          [name]: shiftTimesChanges?.shiftStartTime
            ? moment(shiftTimesChanges?.shiftStartTime).format(
                "YYYY-MM-DDTHH:mm:ss"
              )
            : "",
        });
        Toasts.error("Shift start time should be less than shift end time.");
      }
    }
  };

  const shiftTimesChangesValidation = () => {
    const newErrors = {};

    if (!shiftTimesChanges?.shiftStartTime) {
      newErrors.shiftStartTime = "This field is required";
    }
    if (!shiftTimesChanges?.shiftEndTime) {
      newErrors.shiftEndTime = "This field is required";
    }
    if (!shiftTimesChanges?.checkoutTime) {
      newErrors.checkoutTime = "This field is required";
    }
    if (!shiftTimesChanges?.checkInTime) {
      newErrors.checkInTime = "This field is required";
    }
    setShiftTimesChangesError(newErrors);
  };

  const validateWorkBreaks = (data) => {
    return data.map((item) => {
      const errors = {};

      if (item?.isActive) {
        if (!item.breakTypeId) {
          errors.breakTypeId = "Break type is required";
        }
        if (!item?.breakStartDate) {
          errors.breakStartDate = "Break start date/time is required";
        }
        if (!item?.breakEndDate) {
          errors.breakEndDate = "Break end date/time is required";
        }
        if (
          item?.jobBreakTypeDuration === "0.0000" ||
          !item?.jobBreakTypeDuration
        ) {
          errors.jobBreakTypeDuration = "Break duration is required";
        }
      }
      return {
        ...item,
        errors: errors,
      };
    });
  };


  // Update WorkBreak Info List
  const updateWorkBreakInfo = () => {
    const updatedWorkBreakData = validateWorkBreaks(workBreakListData);
    setWorkBreakListData(updatedWorkBreakData);
    const errorsExist = updatedWorkBreakData.some(
      (item) => Object.keys(item.errors).length > 0
    );
    // API PARAMS
    const params = {
      jobsClaimId: props?.data?.claimedCandidateInfo?.jobsClaimId,
      ...shiftTimesChanges,
      breaksList: workBreakListData?.length
        ? workBreakListData?.map((item) => ({
            jobBreakId: item?.jobBreakId > 1 ? item?.jobBreakId : 0,
            breakType: item?.breakTypeId,
            breakStartTime: item?.breakStartDate,
            breakEndTime: item?.breakEndDate === '0001-01-01T00:00:00' ? null : item?.breakEndDate,
            isActive: item?.isActive,
            isPaidBreak: item?.isPaidBreak
          }))
        : [],
    };
    if (
      shiftTimesChanges?.shiftStartTime &&
      shiftTimesChanges?.shiftEndTime &&
      shiftTimesChanges?.checkInTime &&
      shiftTimesChanges?.checkoutTime
    ) {
      let shiftHours = "";
      if (shiftTimesChanges?.shiftEndTime && shiftTimesChanges?.shiftStartTime) {
        const diffTime =
          new Date(shiftTimesChanges?.shiftEndTime)?.getTime() -
          new Date(shiftTimesChanges?.shiftStartTime)?.getTime();
        shiftHours = diffTime / (1000 * 60);
      } else {
        shiftHours = props?.shiftHours;
      }
      const maxHoursInMins = maxShiftLengthHours * 60 + maxShiftLengthMinutes;
      if (shiftHours > maxHoursInMins) {
        Toasts.error(
          `Maximum allowed shift length is ${maxShiftLengthHours} hours ${
            maxShiftLengthMinutes ? `and ${maxShiftLengthMinutes} mins` : ""
          }. Please select the shift date/time accordingly.`
        );
        // setShiftTimesChanges({
        //   ...shiftTimesChanges,
        //   ['shiftStartTime']: moment(shiftTimesChanges?.shiftStartTime).format(
        //     "YYYY-MM-DDTHH:mm:ss"
        //   ),
        // });
        // return;
      } else {
        // setShiftTimesChanges({
        //   ...shiftTimesChanges,
        //   ['shiftStartTime']: moment(value).format("YYYY-MM-DDTHH:mm:ss"),
        // });
        if (errorsExist) {
          if (workBreakListData?.length && !errorsExist) {
            if (config.baseUrl) {
              dispatch(updateBreakInfo(config.baseUrl, params))
              .then((res) => {
                if (res?.result !== 0) {
                props?.data?.closePopup();
                const url = config.baseUrl;
                const empId = login.employerUniqueId;
                if (props?.data?.jobSummeryJobsShifts?.shiftType !== 2) {
                dispatch(loadShiftAwaitingCorrection({ url, empId }))
                } else {
                dispatch(
                    loadDailyEncounterInfo({
                      url: config.baseUrl,
                      shiftUniqueId: props?.data?.requestData?.jobsShiftUniqueId,
                      jobUniqueId: props?.data?.jobUniqueId,
                    })
                  );
                }
              }
              })
            }
          } 
          } else {
            // Check the duplicate Break
            const hasDuplicatesForBreaks = (arr) => {
              const uniqueKeys = new Set();
              for (const item of arr) {
                  const key = `${item.breakStartDate}_${item.breakEndDate}`;
                  if (uniqueKeys.has(key)) {
                      return true;
                  }
                  uniqueKeys.add(key);
              }
              return false;
            };

            if (!hasDuplicatesForBreaks(workBreakListData)) {
                if (config.baseUrl) {
              dispatch(updateBreakInfo(config.baseUrl, params))
                .then((res) => {
                if (res?.result !== 0) {
                props?.data?.closePopup();
                const url = config.baseUrl;
                const empId = login.employerUniqueId;
                if (props?.data?.jobSummeryJobsShifts?.shiftType !== 2) {
                dispatch(loadShiftAwaitingCorrection({ url, empId }))
                } else {
                  dispatch(
                    loadDailyEncounterInfo({
                      url: config.baseUrl,
                      shiftUniqueId: props?.data?.requestData?.jobsShiftUniqueId,
                      jobUniqueId: props?.data?.jobUniqueId,
                    })
                  );
                }
                }
              })
            }
            } else {
              Toasts.error('Break details should not be same date/time.')
            }
          }
      }
    } else {
      shiftTimesChangesValidation();
    }
  };

  // Reset the
  const resetWorkBreakInfo = () => {
    if (config?.baseUrl) {
      dispatch(
        getViewJobDetails({
          url: config?.baseUrl,
          jobUniqueId: jobId,
          jobsClaimId: claimId,
          shiftDate: shiftDate,
        })
      ).then(() => {
        // Initilize the data work break info
        setWorkBreakListData(
          props?.data?.jobBreakDetailsList?.map((item) => ({
            ...item,
            isActive: true,
            errors: {
              breakTypeId: "",
              breakStartDate: "",
              breakEndDate: "",
              jobBreakTypeDuration: "",
            },
          }))
        );
        // Initialize the shift timings
        setShiftTimesChanges({
          shiftStartTime: props?.data?.claimedCandidateInfo?.jobDate,
          shiftEndTime: props?.data?.claimedCandidateInfo?.jobEndDate,
          checkInTime: props?.data?.claimedCandidateInfo?.checkedInDate,
          checkoutTime: props?.data?.claimedCandidateInfo?.checkedOutDate,
        });
        // remove the error message
        setShiftTimesChangesError({
          shiftStartTime: "",
          shiftEndTime: "",
          checkInTime: "",
          checkoutTime: "",
        });
      });
    }
  };

  return (
    <div>
      <div className="row ms-1">
        <div className="modify-checkintime mb-4 col">
          <label className="form-label">
            Shift Start Time <span className="text-danger">*</span>
          </label>
          <DateTimePicker
            name={"shiftStartTime"}
            value={shiftTimesChanges?.shiftStartTime ? new Date(shiftTimesChanges?.shiftStartTime) : ''}
            onChange={(e) => updateShiftTimeChanges(e)}
            format="MM-dd-yyyy  hh:mm a"
            disabled={
              !props?.data?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
            }
            // required={shiftTimesChangesError?.shiftStartTime ? true : false}
            formatPlaceholder={{
              year: "YYYY",
              month: "MM",
              day: "DD",
              hour: "HH",
              minute: "MIN",
            }}
            className={
             !shiftTimesChanges?.shiftStartTime
              ? "dateTimePickerBorderColor" : ''}
          />
          {!shiftTimesChanges?.shiftStartTime ? (
            <label className="text-danger">
              {shiftTimesChangesError?.shiftStartTime
                ? shiftTimesChangesError?.shiftStartTime
                : ""}
            </label>
          ) : (
            ""
          )}
        </div>
        <div className="modify-checkintime mb-4 col">
          <label className="form-label">
            Shift End Time <span className="text-danger">*</span>
          </label>
          <DateTimePicker
            name={"shiftEndTime"}
            value={shiftTimesChanges?.shiftEndTime ? new Date(shiftTimesChanges?.shiftEndTime) : ''}
            onChange={(e) => updateShiftTimeChanges(e)}
            format="MM-dd-yyyy  hh:mm a"
            disabled={
              !props?.data?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
            }
            // required={shiftTimesChangesError?.shiftEndTime ? true : false}
            formatPlaceholder={{
              year: "YYYY",
              month: "MM",
              day: "DD",
              hour: "HH",
              minute: "MIN",
            }}
            className={
             !shiftTimesChanges?.shiftEndTime
              ? "dateTimePickerBorderColor" : ''}
          />
          {!shiftTimesChanges?.shiftEndTime ? (
            <label className="text-danger">
              {shiftTimesChangesError?.shiftEndTime
                ? shiftTimesChangesError?.shiftEndTime
                : ""}
            </label>
          ) : (
            ""
          )}
        </div>
        <div className="modify-checkintime mb-4 col">
          <label className="form-label">
            Check In Time <span className="text-danger">*</span>
          </label>
          <DateTimePicker
            name={"checkInTime"}
            value={
              shiftTimesChanges?.checkInTime
                ? new Date(shiftTimesChanges?.checkInTime)
                : pickerEmptyStatus.checkInTime ? new Date(shiftTimesChanges?.shiftStartTime) ?? "" :""
            }
            disabled={
              !props?.data?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
            }
            onChange={(e) => updateShiftTimeChanges(e)}
            format= {shiftTimesChanges?.checkInTime
            ? "MM-dd-yyyy  hh:mm a"
            : pickerEmptyStatus.checkInTime ? "MM-dd-yyyy  hh:mm a"  :"MM-dd-yyyy  hh:mm"}
            onOpen={() => setPickerEmptyStatus(prev => ({...prev,["checkInTime"]:true}))}
            onClose={() => setPickerEmptyStatus(prev => ({...prev,["checkInTime"]:false}))}
            // required={shiftTimesChangesError?.checkInTime ? true : false}
            formatPlaceholder={{
              year: "YYYY",
              month: "MM",
              day: "DD",
              hour: "HH",
              minute: "MIN",
            }}
            className={
              !shiftTimesChanges?.checkInTime
              ? "dateTimePickerBorderColor" : ''}
          />
          {!shiftTimesChanges?.checkInTime ? (
            <label className="text-danger">
              {shiftTimesChangesError?.checkInTime
                ? shiftTimesChangesError?.checkInTime
                : ""}
            </label>
          ) : (
            ""
          )}
        </div>
        <div className="modify-checkintime mb-4 col">
          <label className="form-label">
            Check Out Time <span className="text-danger">*</span>
          </label>
          <DateTimePicker
            name={"checkoutTime"}
            value={
              shiftTimesChanges?.checkoutTime
                ? new Date(shiftTimesChanges?.checkoutTime)
                : pickerEmptyStatus.checkoutTime ? new Date(shiftTimesChanges?.shiftEndTime) ?? "" :""
            }
            onOpen={() => setPickerEmptyStatus(prev => ({...prev,["checkoutTime"]:true}))}
            onClose={() => setPickerEmptyStatus(prev => ({...prev,["checkoutTime"]:false}))}
            onChange={(e) => updateShiftTimeChanges(e)}
            format= { shiftTimesChanges?.checkoutTime
              ? "MM-dd-yyyy  hh:mm a"
              : pickerEmptyStatus.checkoutTime ? "MM-dd-yyyy  hh:mm a"  :"MM-dd-yyyy  hh:mm"}
            disabled={
              !props?.data?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
            }
            // required={shiftTimesChangesError?.checkoutTime ? true : false}
            formatPlaceholder={{
              year: "YYYY",
              month: "MM",
              day: "DD",
              hour: "HH",
              minute: "MIN",
            }}
            className={
              !shiftTimesChanges?.checkoutTime
              ? "dateTimePickerBorderColor" : ''}
          />
          {!shiftTimesChanges?.checkoutTime ? (
            <label className="text-danger">
              {shiftTimesChangesError?.checkoutTime
                ? shiftTimesChangesError?.checkoutTime
                : ""}
            </label>
          ) : (
            ""
          )}
        </div>
      </div>

      {workBreakListData?.length &&
      workBreakListData.some((item) => item.isActive) ? (
        <label className="form-label">Work Break Info:</label>
      ) : (
        ""
      )}
      {workBreakListData?.length ? (
        <table className="table">
          {workBreakListData.some((item) => item.isActive) ? (
            <thead>
              <tr>
                <th
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  Break Type
                </th>
                <th
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  Break Start Date / Time
                </th>
                <th
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  Break End Date / Time
                </th>
                <th
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  Break Duration
                </th>
                <th
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  Paid Time
                </th>
                <th
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>
          ) : (
            ""
          )}
          <tbody>
            {workBreakListData?.map((item, index) =>
              item?.isActive ? (
                <tr>
                  <td>
                    <select
                     disabled={
                      !props?.data?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
                    }
                      className="form-control"
                      onChange={(e) =>
                        handleBreakTypeChange(e, item.jobBreakId)
                      }
                      value={item?.breakTypeId || ""}
                      // style={{
                      //   borderColor: !item?.breakTypeId
                      //     ? item?.errors?.breakTypeId
                      //       ? "red"
                      //       : ""
                      //     : "",
                      // }}
                    >
                      <option value={""}>Select Break Type</option>
                      {workBreakList?.map((list) => (
                        <option
                          key={list.breakTypeId}
                          value={list?.breakTypeId}
                        >
                          {list?.breakTypes}
                        </option>
                      ))}
                    </select>
                    {!item?.breakTypeId ? (
                      <span className="mx-1 text-danger">
                        {item?.errors?.breakTypeId}
                      </span>
                    ) : (
                      ""
                    )}
                  </td>

                  {/* Break Start Time */}
                  <td className=" w-25">
                    <DateTimePicker
                      name={"breakStartDate"}
                      value={
                        (item?.breakStartDate && item?.breakStartDate !== '0001-01-01T00:00:00')
                          ? new Date(item?.breakStartDate)
                          : ""
                      }
                      disabled={
                        !props?.data?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
                      }
                      onChange={(e) =>
                        updateStartEndDateValue(
                          e,
                          item?.jobBreakId,
                          item?.breakEndDate
                        )
                      }
                      format="MM-dd-yyyy  hh:mm a"
                      // required={item?.errors?.breakStartDate ? true : false}
                      formatPlaceholder={{
                        year: "YYYY",
                        month: "MM",
                        day: "DD",
                        hour: "HH",
                        minute: "MIN",
                      }}
                      className={!item?.breakStartDate || item?.breakStartDate === '0001-01-01T00:00:00' ? 'dateTimePickerBorderColor' : ''}
                    />
                    {!item?.breakStartDate ? (
                      <span className="text-danger">
                        {item?.errors?.breakStartDate}
                      </span>
                    ) : (
                      ""
                    )}
                  </td>

                  <td className="w-25">
                    <DateTimePicker
                      name={"breakEndDate"}
                      value={
                        (item?.breakEndDate && item?.breakEndDate !== '0001-01-01T00:00:00')
                         ? new Date(item?.breakEndDate) : ""
                      }
                      onChange={(e) =>
                        updateStartEndDateValue(
                          e,
                          item?.jobBreakId,
                          item?.breakStartDate
                        )
                      }
                      disabled={
                        !props?.data?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
                      }
                      format="MM-dd-yyyy  hh:mm a"
                      // required={item?.errors?.breakEndDate ? true : false}
                      formatPlaceholder={{
                        year: "YYYY",
                        month: "MM",
                        day: "DD",
                        hour: "HH",
                        minute: "MIN",
                      }}
                      className={!item?.breakEndDate || item?.breakEndDate === '0001-01-01T00:00:00' ? 'dateTimePickerBorderColor' : ''}
                    />
                    {!item?.breakEndDate ? (
                      <span className="text-danger">
                        {item?.errors?.breakEndDate}
                      </span>
                    ) : (
                      ""
                    )}
                  </td>

                  <td className="">
                    <div>
                      {item.jobBreakTypeDuration
                        ? `${
                            !isNaN(item.jobBreakTypeDuration) && item.jobBreakTypeDuration >= 0
                              ? item.jobBreakTypeDuration
                              : "0.0000"
                          } Hours`
                        : ""}{" "}
                    </div>
                    {item?.jobBreakTypeDuration === "0.0000" ||
                    !item?.jobBreakTypeDuration ? (
                      <span className="text-danger">
                        {item?.errors?.jobBreakTypeDuration}
                      </span>
                    ) : (
                      ""
                    )}
                  </td>
                  <td className="">{item.isPaidBreak ? "Yes" : (item.isPaidBreak === null || item.isPaidBreak === undefined) ? "" : 'No'}</td>
                  <td>
                    <i
                      onClick={() => {
                        deleteWorkBreakRow(index, item?.jobBreakId);
                      }}
                      className="fe fe-trash-2 fa-lg"
                      style={{ cursor: "pointer",  pointerEvents: isDisabled ? 'none' : 'auto' }}
                    ></i>
                  </td>
                </tr>
              ) : (
                ""
              )
            )}
          </tbody>
        </table>
      ) : (
        ""
      )}

      <div className="d-flex justify-content-between gap-2 mt-3">
        <div>
          {props?.data?.jobSummeryJobsShifts?.shiftType !== 2 ?
          <button className="btn btn-primary" 
          disabled={
            !props?.data?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId) || props?.data?.jobSummeryJobsShifts?.shiftType === 2
          }
          onClick={() => addWorkBreak()}>
            Add break
          </button> : ''
          }
        </div>
        <div className="d-flex gap-2">
          <button
             disabled={
              !props?.data?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
            }
            className="btn btn-primary"
            onClick={() => updateWorkBreakInfo()}
          >
            Update
          </button>
          <button
            disabled={
              !props?.data?.claimedCandidateInfo?.approversList?.some(item => item.approverUserUniqueId === login.appUserUniqueId)
            }
            className="btn btn-primary"
            onClick={() => resetWorkBreakInfo()}
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default WorkBreakInfo;
